import { loadStripe } from '@stripe/stripe-js';

export const STATUS_STARTED = 'started';
export const STATUS_IN_PROGRESS = 'in-progress';
export const STATUS_APPROVED = 'approved';
export const STATUS_DECLINED = 'declined';

let stripePromise = null;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Opens the Stripe Identity verification modal. Mirrors the previous
// Veriff helper signature so callers don't need to change.
//
// onCreateVerification → resolves the session (returns clientSecret)
// onUpdateVerification → flips local user status to "in-progress"
// onFetchCurrentUser   → reloads the current user after the modal closes
export const onOpenVeriffModal = async (
  onCreateVerification,
  onUpdateVerification,
  onFetchCurrentUser,
  existingClientSecret
) => {
  const clientSecret = existingClientSecret
    ? existingClientSecret
    : await onCreateVerification();

  if (!clientSecret) return;

  const stripe = await getStripe();
  if (!stripe) {
    console.error('Stripe.js failed to load');
    return;
  }

  const { error } = await stripe.verifyIdentity(clientSecret);

  // The modal has closed — refresh user state and mark in-progress.
  // Stripe processes the document async; the webhook flips status to
  // approved/declined when the result is final.
  await onFetchCurrentUser();
  if (!error) {
    return onUpdateVerification(STATUS_IN_PROGRESS);
  }
};
